import React, { useState } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";

const STORAGE_KEY = "service_pr_approvals_filter";

const ServicePrApprovalsFilter = ({ applyFilter }) => {
  const filterInputs = {
    site_no: "",
    pr_id: "",
  };

  const savedFilter = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");

  const [filterFieldsData, setFilterFieldsData] = useState({
    site_no: savedFilter?.site_no || "",
    pr_id: savedFilter?.pr_id || "",
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(filterFieldsData));
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />

      <ConstantInput
        label="PR Number"
        value={filterFieldsData.pr_id}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, pr_id: val })
        }
      />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            window.localStorage.removeItem(STORAGE_KEY);
            setFilterFieldsData(filterInputs);
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default ServicePrApprovalsFilter;
